import { render, staticRenderFns } from "./table-cp.vue?vue&type=template&id=b4bde298&scoped=true"
import script from "./table-cp.vue?vue&type=script&lang=js"
export * from "./table-cp.vue?vue&type=script&lang=js"
import style0 from "./table-cp.vue?vue&type=style&index=0&id=b4bde298&prod&lang=less&scoped=true"
import style1 from "./table-cp.vue?vue&type=style&index=1&id=b4bde298&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bde298",
  null
  
)

export default component.exports